export default "__VITE_ASSET__Cf_IYFza__"